import { useMemo } from "react";
import { useAuthContext } from "../context/AuthContext/AuthContext";

export const useFilteredCategories = (categories?: any[]): any[] => {
  const authCtx = useAuthContext();

  const filteredCategories = useMemo(() => {
    if (!authCtx.isAuthenticated || !authCtx.user) {
      return categories || [];
    }

    const showCategories = authCtx.user.showCategories;
    if (!showCategories || showCategories.length === 0) {
      return categories || [];
    }

    const allowedCategoryIds = showCategories
      .filter((cat) => cat && cat.databaseId != null)
      .map((cat) => cat.databaseId.toString());
    
    const filterCategoryTree = (cats: any[], parentAllowed: boolean = false): any[] => {
      return cats.filter(category => {
        if (!category || category.databaseId == null) {
          return false;
        }

        if (parentAllowed) {
          return true;
        }
        
        if (allowedCategoryIds.includes(category.databaseId.toString())) {
          return true;
        }
        
        if (category.children?.nodes?.length > 0) {
          const filteredChildren = filterCategoryTree(category.children.nodes, false);
          if (filteredChildren.length > 0) {
            return true;
          }
        }
        
        return false;
      }).map(category => {
        const categoryAllowed = allowedCategoryIds.includes(category.databaseId.toString());
        return {
          ...category,
          children: category.children?.nodes?.length > 0 ? {
            nodes: filterCategoryTree(category.children.nodes, categoryAllowed || parentAllowed)
          } : category.children
        };
      });
    };

    return filterCategoryTree(categories || []);
  }, [categories, authCtx.isAuthenticated, authCtx.user?.showCategories]);

  return filteredCategories;
}; 